import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';

import { useNavigate, useParams } from 'react-router-dom';

import { GetCompany, GetRoles, PostCompanyBusinessInfo, PostUser } from '../services/httpServices';

import { styled } from '@mui/material/styles';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
const BusinessInforamtion = (props) => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [company, setCompany] = useState({});

  const [open, setOpen] = useState(false);

  const [loading, setLoading] = useState(true);

  const [businessType, setBusinessType] = useState('Incorporated');
  const [isbusinessFranchise, setIsbusinessFranchise] = useState(false);
  const [isCorporateHeadOffice, setIsCorporateHeadOffice] = useState('Yes');
  const [isReson, setIsReason] = useState(true);

  const corporationNameRef = useRef('');
  const reasonRef = useRef('');

  const fetchCompany = async (event) => {
    const company = await GetCompany(id);
    setBusinessType(company.businessInformations[0].businessType);
    setIsbusinessFranchise(company.businessInformations[0].isBusinessFranchise == 'true' ? true : false);
    setIsReason(company.businessInformations[0].temporaryWorker == 'Not Applicable' ? false : true);
    setIsCorporateHeadOffice(company.businessInformations[0].temporaryWorker);
    // setLmiaRevoked(company.companyInformations[0].lmiarevoked == 'true' ? true : false);
    setCompany(company);
    setLoading(false);
  };

  useEffect(() => {
    fetchCompany();
  }, []);
  // #endregion Refs

  const SaveUser = async (event) => {
    // setPosting(true);
    event.preventDefault();
    //console.log('saveHit');
    const payload = {
      businessType: businessType,
      isBusinessFranchise: isbusinessFranchise,
      corporationName: corporationNameRef.current.value,
      temporaryWorker: isCorporateHeadOffice,
      reason: reasonRef.current.value,
    };

    //console.log(payload);

    let response = await PostCompanyBusinessInfo(id, payload);
    //console.log('PostResponse:', response);

    if (response.status == 200) {
      setLoading(false);
      props.setMessage("Company's Business Information added successfully.");
      let companySaved = company;
      companySaved.businessInformations[0] = response.data;
      setCompany(companySaved);
      props.setSaved(true);
      props.setOpen(true);
      //console.log('Id:', id);
      // setTimeout(() => {
      //   navigate(`/app/EditCompany/${id}`);
      // }, 2000);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      // setPosting(false);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleChange = (event) => {
    setBusinessType(event.target.value);
  };
  const handleChangeIsCorporate = (event) => {
    setIsCorporateHeadOffice(event.target.value);
    event.target.value == 'Not Applicable' ? setIsReason(false) : setIsReason(true);
    if (event.target.value == 'Not Applicable') {
      reasonRef.current.value = company.businessInformations[0]?.reason;
    } else {
      reasonRef.current.value = '';
    }
  };
  const handleChangeBusinessFranchise = (event) => {
    event.target.value == 'true' ? setIsbusinessFranchise(true) : setIsbusinessFranchise(false);
    if (event.target.value == 'true') {
      corporationNameRef.current.value = company.businessInformations[0]?.corporationName;
    } else {
      corporationNameRef.current.value = '';
    }
  };

  return (
    <>
      <form onSubmit={SaveUser}>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box component={Paper} p={1}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        Please check the appropriate business type:
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={businessType}
                        onChange={handleChange}
                      >
                        <FormControlLabel value="Incorporated" control={<Radio />} label="Incorporated / Limited" />
                        <FormControlLabel value="Partnership" control={<Radio />} label="Partnership" />
                        <FormControlLabel value="SoleProprietor" control={<Radio />} label="Sole Proprietor" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">Is this a business franchise?</FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={isbusinessFranchise}
                        onChange={handleChangeBusinessFranchise}
                      >
                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                        <FormControlLabel value="false" control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  <Grid direction="column" item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        If yes, provide the name of the Corporation:
                      </FormLabel>
                    </FormControl>
                    <Item>
                      <TextField
                        label="Corporation Name"
                        variant="outlined"
                        fullWidth
                        size="small"
                        required
                        defaultValue={company.businessInformations[0]?.corporationName}
                        disabled={!isbusinessFranchise}
                        inputRef={corporationNameRef}
                      />
                    </Item>
                  </Grid>

                  <Grid item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        If your business is a franchise, is the corporate head office aware of this application for
                        temporary foreign Workers(TFW)?
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={isCorporateHeadOffice}
                        onChange={handleChangeIsCorporate}
                      >
                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                        <FormControlLabel value="No" control={<Radio />} label="No" />
                        <FormControlLabel value="Not Applicable" control={<Radio />} label="Not Applicable" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid direction="column" item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        If not applicable specify the Reason:
                      </FormLabel>
                    </FormControl>
                    <Item>
                      <TextField
                        label="Reason"
                        variant="outlined"
                        disabled={isReson}
                        fullWidth
                        required
                        defaultValue={company.businessInformations[0]?.reason}
                        size="small"
                        inputRef={reasonRef}
                      />
                    </Item>
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}></Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <Button type="submit" variant="contained">
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        )}
      </form>
    </>
  );
};

export default BusinessInforamtion;
